import "./index.css";
import { jsx as t } from "react/jsx-runtime";
import { Button as o } from "@design-system/button";
import { RTEText as e } from "@design-system/rte-text";
import i from "@phx-husky/tooltip";
import n from "classnames";
import { forwardRef as s } from "react";
var r = s(function (_ref, x) {
  var s = _ref.className,
    r = _ref.tooltipWindowClassName,
    l = _ref.portalQuerySelector,
    c = _ref.label,
    a = _ref.text,
    p = _ref.content,
    _ref$isTooltipContent = _ref.isTooltipContentInteractive,
    m = _ref$isTooltipContent === void 0 ? !1 : _ref$isTooltipContent,
    _ref$icon = _ref.icon,
    d = _ref$icon === void 0 ? "tooltip" : _ref$icon,
    u = _ref.onClickTooltip,
    f = _ref.onBlurTooltip;
  return t("div", Object.assign({
    ref: x,
    className: n("cds-tooltip", s)
  }, {
    children: t(i, Object.assign({
      placement: "top-end",
      className: n("cds-tooltip-window", r),
      title: a && t(e, {
        text: a
      })
    }, {
      content: p,
      isTooltipContentInteractive: m,
      portalQuerySelector: l
    }, {
      children: t(o, Object.assign({
        variant: "subtle-icon",
        iconPrefix: {
          props: {
            icon: d
          }
        },
        className: "cds-tooltip__button",
        onClick: u,
        onBlur: f
      }, {
        children: c
      }))
    }))
  }));
});
export { r as Tooltip };